/*
 * Toggle the flyout menu on button clicks
 *
 * Close the flyout menu when the screen is resized above a breakpoint
 */

function closeFlyout(flyoutOpenClasses) {
    document.documentElement.classList.remove('noScroll');
    document.body.classList.remove(...flyoutOpenClasses);
}

function toggleFlyout(flyoutOpenClasses) {
    document.documentElement.classList.toggle('noScroll');
    document.body.classList.toggle(...flyoutOpenClasses);
}

function initFlyout(watcher, flyoutInitClasses) {
    if (watcher.matches) {
        document.body.classList.add(...flyoutInitClasses);
    } else {
        document.body.classList.remove(...flyoutInitClasses);
    }
}

function handleResize(watcher, flyoutOpenClasses, flyoutInitClasses) {
    if (!watcher.matches) {
        closeFlyout(flyoutOpenClasses);
    }

    initFlyout(watcher, flyoutInitClasses);
}

/*
 * breakpoint (int) : the breakpoint in pixels above which the flyout is hidden
 *
 * buttonClass (string) : the CSS class for the button(s)
 *
 * flyoutOpenClasses ([string]) : CSS classes added to the document body when the
 * flyout is opened
 *
 * flyoutInitClasses ([string]) : optional classes to apply to the document body when
 * below the flyout breakpoint
 *
 * example: flyoutMenu(1120, 'js_flyoutButton', ['flyoutOpen'], ['flyoutInit'])
 */
function flyoutMenu(breakpoint, buttonClass, flyoutOpenClasses, flyoutInitClasses = []) {
    const mediaQuery = `(max-width:${breakpoint}px)`,
          watcher = window.matchMedia(mediaQuery),
          buttons = [...document.getElementsByClassName(buttonClass)];

    buttons.forEach(button => button.addEventListener('click', e => toggleFlyout(flyoutOpenClasses)));

    watcher.addEventListener('change', e => handleResize(watcher, flyoutOpenClasses, flyoutInitClasses));

    initFlyout(watcher, flyoutInitClasses);
}

export default flyoutMenu;
